import React from 'react'
import { StatusBadge } from '@mobi/component-library/Feedback/StatusBadge'
import { Icon } from '@mobi/component-library/Assets/Icon'

export const LiveStatusBadge: React.FC = () => {
  return (
    <StatusBadge color='crimson' badgeSize='S'>
      <Icon name='SolidCircle' size='0.8rem' /> Live
    </StatusBadge>
  )
}
